import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";

// Slim, always-visible contact bar shown only on phones/tablets (hidden on lg+).
// Hidden on the Contact page itself (the enquiry form is already there).
// The right margin on the primary button reserves space so the floating Cassie
// button never overlaps it.
export default function MobileStickyCta() {
  const { pathname } = useLocation();
  if (pathname === "/contact") return null;
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-navy/95 backdrop-blur border-t border-white/10 px-3 pt-2.5 flex items-center gap-2"
      style={{ paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))" }}
    >
      <a
        href="tel:01827780550"
        data-testid="mobile-cta-call"
        aria-label="Call CASS"
        className="shrink-0 w-11 h-11 rounded-full bg-white/10 text-white flex items-center justify-center active:scale-95 transition-transform"
      >
        <Phone size={18} />
      </a>
      <Link
        to="/contact"
        data-testid="mobile-cta-lets-talk"
        className="flex-1 mr-[4.5rem] inline-flex items-center justify-center gap-2 bg-orange text-white font-bold text-sm h-11 rounded-full active:scale-[0.98] transition-transform"
      >
        Let's Talk <ArrowRight size={16} />
      </Link>
    </div>
  );
}
